import React from "react";
import "./Answers.css";

const Answers = () => {
  return (
    <div className="answers">
      <div className="wrapper">
        <div className="answers-intro-heading">
          <h2>Co można wydobyć z&nbsp;przedstawionych fragmentów?</h2>
        </div>
      </div>
      <div className="answers-specialization">
        <h3>Sceny w&nbsp;kontekście całego utworu:</h3>
        <p>
          Obydwie sceny pochodzą z&nbsp;drugiego aktu i&nbsp;mają charakter
          <b> symboliczno-wizyjny</b>. Są dowodem nowatorstwa w&nbsp;dziedzinie
          rozwoju form dramaturgicznych.
        </p>
        <p>
          Pierwsza przedstawia <b>chochoła</b>, który&nbsp;
          <mark>zapowiada gości „z&nbsp;zaświatów”</mark>, druga&nbsp;
          <mark>
            prezentuje spotkanie&nbsp;
            <b>Poety</b> z&nbsp;widmem
            <b> Rycerza</b>
          </mark>
          .
        </p>
        <p>
          Poszerzają portret psychologiczny <b>Poety</b>, odsłaniając jego
          &nbsp;
          <mark>
            duchowe rozterki symbolicznie uosabiane przez zjawę <b>Rycerza</b>
          </mark>
          .
        </p>
        <br />
        <h3>Analiza pierwszego fragmentu:</h3>
        <p>
          Bohaterem jest <b>chochoł</b> – snop słomy służący do okrywania drzew
          i&nbsp;krzewów przed zimnem.
        </p>
        <p>
          W&nbsp;podanej scenie zostaje <mark>upersonifikowany</mark>: mówi,
          wygłasza zagadkowe proroctwa, zapowiada niezwykły, pełen grozy
          spektakl, który ma się rozegrać pod osłoną nocy.
        </p>
        <p>
          Wypowiadając słowa: "Co się w&nbsp;duszy komu gra, co kto
          w&nbsp;swoich widzi snach" – ujawnia, że przybyłe zjawy stanowią&nbsp;
          <mark>
            projekcję wewnętrznych konfliktów i&nbsp;dylematów weselnych gości
          </mark>
          , a nie niezależne byty świata nadprzyrodzonego.
        </p>
        <br />
        <h3>Analiza drugiego fragmentu:</h3>
        <p>
          Rozgrywa się w&nbsp;<mark>konwencji romantycznego teatru grozy</mark>:
          świat realny, którego przedstawicielem jest <b>Poeta</b>, przenika
          wizja – sen uosobiona w&nbsp;postaci mrocznego, posępnego widma&nbsp;
          <b>Rycerza</b>.
        </p>
        <p>Bohaterowie:</p>
        <p>
          <b>Poeta</b> – wydaje się zagubiony, przytłoczony nieprzewidywalnym
          biegiem wydarzeń. Ma poczucie osaczenia przez widmo, próbuje mu się
          wymknąć, nie rozumie słów <b>Rycerza</b> nakłaniającego do podjęcia
          czynu. Przejawia słabość, wszystko bierze za&nbsp;urojenia, nie
          poddaje się sugestiom <b>widma</b> o&nbsp;wielkiej roli, jaką mógłby
          odegrać w&nbsp;dziejach narodu jako poeta – duchowy przywódca narodu
          (Łzy mnie pieką, łzy mnie pieką, czymże bym ja tam być miał.)
        </p>
        <p>
          <b>Rycerz</b> – to&nbsp;
          <mark>
            marzenie senne <b>Poety</b>
          </mark>
          &nbsp;(Głos jak marzeń moich piastun),&nbsp;
          <mark>projekcja jego pragnień i&nbsp;dylematów</mark>, przybierająca
          postać bohatera spod Grunwaldu – Zawiszy Czarnego.&nbsp;
          <mark>Uosabia on siłę, moc,</mark>&nbsp;której brakuje <b>Poecie</b>.
          (Ja Moc: za mną, przede mną ognia kurz; po drogach, po których lecę,
          drzewa się palą jak świece, ciskają się błyskawice).&nbsp;
          <mark>Zwiastuje zwycięstwo, ale także śmierć</mark>, którą każdy
          triumf musi być okupiony (kiedy odchyla przyłbicę, ukazuje śmiertelne
          oblicze). Przypomina bohaterowi czasy potężnej Polski Jagiellonów
          zdolnej do heroicznego czynu. Namawia go, aby stamtąd czerpał siłę
          i&nbsp; inspirację do działania. Widzi <b>Poetę</b> w podniosłej
          roli&nbsp;
          <mark>wieszcza sięgającego po duchowe przywództwo</mark>, który obudzi
          uśpiony naród i&nbsp;popchnie go do walki.
        </p>
        <br />
        <h3>Wniosek:</h3>
        <p>
          <mark>Wizja senna odsłania podświadome pragnienia bohatera</mark>,
          pokazuje <b>Poetę</b> jako człowieka rozdartego wewnętrznie,
          o&nbsp;niestabilnej, rozchwianej osobowości. Z&nbsp;jednej strony –
          jak romantyczni bohaterowie – <mark>marzy mu się rola wieszcza</mark>,
          który swoją poezją porywa tłumy do walki i&nbsp;fetuje zwycięstwo,
          z&nbsp;drugiej&nbsp;
          <mark>walczy z&nbsp;własną słabością i&nbsp;niezdecydowaniem</mark>.
          Ma świadomość, że tej roli nie potrafi unieść tak ze względu
          nieodpowiednich predyspozycji psychicznych jak i&nbsp;dylematów
          moralnych. Wie, że taka poezja, o&nbsp;jakiej marzy, niesie ze sobą
          śmierć i&nbsp;zniszczenie. Marzenia rozbudzają jego wyobraźnię, ale
          jednocześnie przerastają <b>Poetę</b>, stając się&nbsp;
          <mark>źródłem walki wewnętrznej i&nbsp;konfliktów moralnych</mark>.
        </p>
      </div>
      <div className="wrapper">
        <div className="answers-intro-heading">
          <h2>Jak funkcjonalnie odnieść się do całości utworu?</h2>
        </div>
      </div>
      <div className="answers-specialization">
        <h3>
          Wiedza na temat całości utworu niewątpliwie pomoże w&nbsp;
          interpretacji podanej sceny:
        </h3>
        <p>
          Odwołaj się do tego, co wiesz o&nbsp;<b>Poecie</b> na podstawie
          chociażby I aktu: to&nbsp;
          <mark>
            dekadent porażony niemocą, poddający się schyłkowym nastrojom końca
            wieku
          </mark>
          . Tkwi w&nbsp;artystycznym marazmie, pisze wiersze skażone smutkiem
          i&nbsp; melancholią, ale marzy mu się poemat o&nbsp;rycerzu w
          &nbsp;srebrnej zbroi. Nosi w&nbsp;sobie jakieś nieokreślone pragnienie
          czynienia rzeczy wielkich, ale – jak sam mówi –&nbsp;
          <mark>pospolitość skrzeczy</mark>. Jeśli będziesz o&nbsp;tym pamiętał,
          łatwiej zrozumiesz, dlaczego&nbsp;
          <mark>
            Zawisza Czarny staje się w&nbsp;utworze symbolem pragnień i
            &nbsp;tęsknot&nbsp;
            <b>Poety</b>
          </mark>
          .
        </p>
        <p>
          Przedstaw analizowaną scenę jako integralną część wielkiego spektaklu
          zjaw, który ma na celu pogłębić charakterystykę inteligencji
          z&nbsp;przełomu wieków. Podkreśl, że&nbsp;
          <mark>
            symboliczna wizja staje się w&nbsp;dramacie Wyspiańskiego ogólną
            metodą budowania wizerunków postaci
          </mark>
          .
        </p>
        <br />
        <h3>
          Konteksty interpretacyjne, czyli do czego warto się odwołać analizując
          podane fragmenty?
        </h3>
        <p>
          Warto wspomnieć, że pierwowzorem postaci <b>Poety</b> był w
          &nbsp;rzeczywistości <b>Kazimierz Przerwa-Tetmajer</b>,&nbsp;
          <mark>bard pokolenia dekadentów</mark> i&nbsp;jednocześnie autor
          dramatu "Zawisza Czarny".
        </p>
        <p>
          Zauważ wyraźne&nbsp;
          <mark>
            nawiązanie do konwencji II części "Dziadów" Adama Mickiewicza
          </mark>
          . W&nbsp;przedstawionej scenie jak i&nbsp;całym II akcie – jak w
          &nbsp;"Dziadach" – czytelnik staje się świadkiem&nbsp;
          <mark>mrocznego widowiska z&nbsp;udziałem zjaw</mark>, które
          pozostawiają gościom weselnym określone przesłania.
        </p>
      </div>
      <br />
      <p>
        <em>aleklasa.pl/matura/c266-lektury-klucze-maturalne/wesele-matura</em>
      </p>
    </div>
  );
};

export default Answers;
